var version = {
    "name":      "dativery",
    "buildDateCode": "20260819-152813",
    "buildDate": "Wed Aug 19 2026 15:28:13 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260819-152813",
    "backupUIVersion": "2.2.0-20250519-102244"
}
;
 export default version;